import React from "react"

export default function Select({ children, className, optionStyles, ...rest }) {
  return (
    <select className={className} optionstyles={optionStyles} {...rest}>
      {children}
    </select>
  )
}
